<template>
  <ConfirmationModal
    :title="$t('ACCOUNT_BILLING_CURRENT_PRICING_MODAL_HEADER')"
    :show-confirm-button="false"
    :show-cancel-button="false"
    @close="$emit('close')" 
  >
    <div class="container-fluid">
      <div class="row form-group">
        <div class="col-sm-6">
          {{ $t("ACCOUNT_BILLING_RECORDING_PRICING") }}
        </div>
        <div class="col-sm-6">
          {{ pricingPlan.recordingCost | currency }} /
          {{ $t("ACCOUNT_BILLING_RECORDING_MINUTE") }}
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-6">
          {{ $t("ACCOUNT_BILLING_ICP_PRICING") }}
        </div>
        <div class="col-sm-6">
          {{ pricingPlan.dataEnrichmentCost | currency }} /
          {{ $t("ACCOUNT_BILLING_ICP_REQUEST") }}
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-6">
          {{ $t("ACCOUNT_BILLING_TRANSCRIPTION_PRICING") }}
        </div>
        <div class="col-sm-6">
          {{ pricingPlan.transcriptionCost | currency }} /
          {{ $t("ACCOUNT_BILLING_TRANSCRIPTION_MINUTE") }}
        </div>
      </div>
      <table class="table_beauty m-t-10">
        <thead>
          <tr>
            <th>{{ $t("COUNTRY") }}</th>
            <th>$/month (DID)</th>
            <th>$/month (TF)</th>
            <th>$/min (DID)</th>
            <th>$/min (TF)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(override, index) in formattedOverrides" :key="index">
            <td>
              <CountryFlag
                v-if="override.country !== 'Default'"
                :countryCode="override.country"
                class="m-r-3"
              />
              {{ override.country }}
            </td>
            <td>{{ override.numberPurchaseDID }}</td>
            <td>{{ override.numberPurchaseTF }}</td>
            <td>{{ override.costPerMinuteDID }}</td>
            <td>{{ override.costPerMinuteTF }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ConfirmationModal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import sharedMessages from '@/core/locales';
import messages from '../../locales';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import CountryFlag from '@/core/components/CountryFlag/CountryFlag';
import formatCurrency from '@/core/filters/formatCurrency';

export default {
  components: {
    ConfirmationModal,
    CountryFlag,
  },
  filters: {
    currency(value) {
      return formatCurrency(value, 'en-US', 3);
    }
  },
  computed: {
    ...mapState('billingSettingsStore', ['pricingPlan']),
    formattedOverrides() {
      if (!this.pricingPlan?.overrides) return [];

      const formatOverride = (country, values, isDefault = false) => ({
        country: isDefault ? country : country.toUpperCase(),
        numberPurchaseDID: values.numberPurchaseDID ? formatCurrency(values.numberPurchaseDID, 'en-US', 2) : '',
        costPerMinuteDID: values.costPerMinuteDID ? formatCurrency(values.costPerMinuteDID, 'en-US', 3) : '',
        numberPurchaseTF: values.numberPurchaseTF ? formatCurrency(values.numberPurchaseTF, 'en-US', 2) : '',
        costPerMinuteTF: values.costPerMinuteTF ? formatCurrency(values.costPerMinuteTF, 'en-US', 3) : '',
      });

      const countryOverrides = Object.entries(this.pricingPlan.overrides)
        .map(([country, value]) => formatOverride(country, value))
        .sort((a, b) => a.country.localeCompare(b.country));

      const defaultOverride = formatOverride('Default', {
        numberPurchaseDID: this.pricingPlan.defaultNumberCostDID,
        costPerMinuteDID: this.pricingPlan.defaultCostPerMinuteDID,
        numberPurchaseTF: this.pricingPlan.defaultNumberCostTF,
        costPerMinuteTF: this.pricingPlan.defaultCostPerMinuteTF,
      }, true);

      return [defaultOverride, ...countryOverrides];
    }
  },
  methods: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  i18n: {
    locale: 'en',
    sharedMessages,
    messages
  }
};
</script>